import React from 'react';

/**
 * AnswerOption Component
 * Individual answer card/button that can be selected
 * 
 * @param {object} answer - Answer object with id, text
 * @param {boolean} selected - Whether this answer is selected
 * @param {function} onSelect - Callback when answer is clicked
 */
export default function AnswerOption({ answer, selected, onSelect }) {
  return (
    <button
      onClick={() => onSelect(answer.id)}
      className={`
        answer-card text-left w-full
        ${selected ? 'answer-card-selected' : ''}
      `}
      aria-pressed={selected}
    >
      <div className="flex items-center justify-between">
        <span className="text-sm sm:text-base md:text-lg text-white pr-3 sm:pr-4">
          {answer.text}
        </span>
        
        {/* Checkmark indicator when selected */}
        {selected && (
          <span className="flex-shrink-0 text-teal-accent text-xl sm:text-2xl" aria-hidden="true">
            ✓
          </span>
        )}
      </div>
    </button>
  );
}

